import { loadStripe } from '@stripe/stripe-js';

// Stripe publishable key - safe to expose in frontend
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51RvMpz5mzAWOydCsgqHF1QIjeI6iYzBwp6kkQYQFehJuBKvAaEpZgAb8LKhXv1opfcavm33Nqhr4qqI1M89ul1eq00QjUXWx1i';

console.log('🔑 Frontend using Stripe Publishable Key:', STRIPE_PUBLISHABLE_KEY.substring(0, 12) + '...');

// Initialize Stripe with error handling
export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY).catch(error => {
  console.error('Failed to load Stripe.js:', error);
  return null;
});

// Stripe product configuration
export const STRIPE_PRODUCTS = {
  // Signature Cakes
  'tres-leches-traditional': {
    priceId: 'price_1RvNhn5mzAWOydCs1RWWCSUw', // Your actual Stripe price ID
    productId: 'prod_Sr5tw9tQz08AFt', // Your actual Stripe product ID
    name: '3 milk cake (Tres leches)',
    price: 850, // Price in pence (£8.50)
    currency: 'gbp'
  },
  'tres-leches-chocolate': {
    priceId: 'price_demo_chocolate', // Demo price ID
    productId: 'prod_demo_chocolate',
    name: '3 milk cake with Chocolate',
    price: 900, // £9.00
    currency: 'gbp'
  },
  'tres-leches-caramel': {
    priceId: 'price_demo_caramel',
    productId: 'prod_demo_caramel',
    name: '3 milk cake with Caramel',
    price: 900, // £9.00
    currency: 'gbp'
  },
  'tres-leches-lotus': {
    priceId: 'price_demo_lotus',
    productId: 'prod_demo_lotus',
    name: '3 milk cake with Lotus',
    price: 900, // £9.00
    currency: 'gbp'
  },
  // Coming Soon Products
  'tres-leches-bueno': {
    priceId: 'price_demo_bueno',
    productId: 'prod_demo_bueno',
    name: '3 milk cake with Bueno',
    price: 900, // £9.00
    currency: 'gbp'
  },
  'tres-leches-oreo': {
    priceId: 'price_demo_oreo',
    productId: 'prod_demo_oreo',
    name: '3 milk cake Oreo',
    price: 900, // £9.00
    currency: 'gbp'
  },
  'tres-leches-pistachio': {
    priceId: 'price_demo_pistachio',
    productId: 'prod_demo_pistachio',
    name: '3 milk cake Pistachio',
    price: 900, // £9.00
    currency: 'gbp'
  },
  'tres-leches-tiramisu': {
    priceId: 'price_demo_tiramisu',
    productId: 'prod_demo_tiramisu',
    name: '3 milk cake Tiramisu',
    price: 900, // £9.00
    currency: 'gbp'
  },
  // Specialty Cakes
  'impossible-cake': {
    priceId: 'price_demo_impossible',
    productId: 'prod_demo_impossible',
    name: 'Impossible Cake 8"',
    price: 4200, // £42.00
    currency: 'gbp'
  },
  'quesillo': {
    priceId: 'price_demo_quesillo',
    productId: 'prod_demo_quesillo',
    name: 'Quesillo 8"',
    price: 2800, // £28.00
    currency: 'gbp'
  },
  'carrot-cake': {
    priceId: 'price_demo_carrot',
    productId: 'prod_demo_carrot',
    name: 'Carrot Cake 8"',
    price: 4600, // £46.00
    currency: 'gbp'
  },
  'burrera': {
    priceId: 'price_demo_burrera',
    productId: 'prod_demo_burrera',
    name: 'Burrera',
    price: 3800, // £38.00
    currency: 'gbp'
  },
  'red-velvet': {
    priceId: 'price_demo_redvelvet',
    productId: 'prod_demo_redvelvet',
    name: 'Red Velvet 8"',
    price: 4600, // £46.00
    currency: 'gbp'
  },
  'chocolate-cake': {
    priceId: 'price_demo_chococake',
    productId: 'prod_demo_chococake',
    name: 'Chocolate Cake',
    price: 3800, // £38.00
    currency: 'gbp'
  },
  // Special Items
  'chocolate-tres-leches': {
    priceId: 'price_demo_chocotres',
    productId: 'prod_demo_chocotres',
    name: '3 milk chocolate cake',
    price: 4500, // £45.00
    currency: 'gbp'
  },
  // Cupcakes
  'cupcakes': {
    priceId: 'price_demo_cupcakes',
    productId: 'prod_demo_cupcakes',
    name: 'Vanilla / Chocolate / Carrot cupcakes',
    price: 300, // £3.00 each
    currency: 'gbp'
  }
};

// Function to redirect to Stripe Checkout (legacy)
export const redirectToCheckout = async (priceId, quantity = 1) => {
  try {
    const stripe = await stripePromise;

    if (!stripe) {
      throw new Error('Stripe failed to load');
    }

    const { error } = await stripe.redirectToCheckout({
      lineItems: [
        {
          price: priceId,
          quantity: quantity,
        },
      ],
      mode: 'payment',
      successUrl: `${window.location.origin}/success?session_id={CHECKOUT_SESSION_ID}`,
      cancelUrl: `${window.location.origin}/menu`,
    });

    if (error) {
      console.error('Stripe checkout error:', error);
      alert('There was an error processing your payment. Please try again.');
    }
  } catch (error) {
    console.error('Error redirecting to checkout:', error);
    alert('There was an error processing your payment. Please try again.');
  }
};

// Function to create payment intent for Stripe Elements
export const createPaymentIntent = async (productId, quantity = 1) => {
  try {
    const product = STRIPE_PRODUCTS[productId];
    if (!product) {
      throw new Error('Product not found');
    }

    // In a real application, this would call your backend
    // For now, we'll simulate the payment intent creation
    const response = await fetch('/api/create-payment-intent', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amount: product.price * quantity,
        currency: product.currency,
        productId: productId,
        quantity: quantity,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to create payment intent');
    }

    const { client_secret } = await response.json();
    return client_secret;
  } catch (error) {
    console.error('Error creating payment intent:', error);
    throw error;
  }
};

// Helper function to get product data for checkout
export const getProductForCheckout = (productId) => {
  const stripeProduct = STRIPE_PRODUCTS[productId];
  if (!stripeProduct) {
    return null;
  }

  return {
    id: productId,
    name: stripeProduct.name,
    price: `£${(stripeProduct.price / 100).toFixed(2)}`,
    priceInCents: stripeProduct.price,
    currency: stripeProduct.currency,
    priceId: stripeProduct.priceId,
    productId: stripeProduct.productId,
  };
};
